import {
  CheckOutScheduleItem,
  OrderCargoSeparateItem,
  OrderCargoTotal,
  OrderItem,
  OrderItemClient,
  OrderItemCompany,
  OrderItemContact,
  OrderItemPartner,
  OrderItemPoint,
  PaymentItem,
  PaymentTransactionCreateFromOrderRequest
} from 'schema'

import { TOrderGuestCreateCompany } from './orderGuestCreateTypes'

export * from './orderCreateTypes'
export * from './orderGuestCreateTypes'

export type TOrder = OrderItem

export enum TrackingStatusEnum {
  departureCourier = 'departureCourier',
  departureCourierAssigned = 'departureCourierAssigned',
  departureTerminal = 'departureTerminal',
  destinationCourier = 'destinationCourier',
  destinationTerminal = 'destinationTerminal',
  transit = 'transit'
}

export const ORDER_STATUS = Object.freeze({
  [OrderItem.Status.NEW]: 'В обработке',
  [OrderItem.Status.DEPARTURE_COURIER_ASSIGNED]: 'Ожидает забора',
  [OrderItem.Status.DEPARTURE_COURIER]: 'Принято курьером',
  [OrderItem.Status.DEPARTURE_TERMINAL]: 'Готово к отправке',
  [OrderItem.Status.DESTINATION_TERMINAL]: 'Груз прибыл',
  [OrderItem.Status.DESTINATION_COURIER_ASSIGNED]: 'Ожидает доставки',
  [OrderItem.Status.DESTINATION_COURIER]: 'Доставка курьером',
  [OrderItem.Status.TRANSIT]: 'Перевозка',
  [OrderItem.Status.DELIVERED]: 'Исполнена',
  [OrderItem.Status.CANCEL]: 'Отменена'
})

export const ORDER_PAYMENT_STATUS = Object.freeze({
  [OrderItem.paymentStatus.FULL]: 'Оплачено',
  [OrderItem.paymentStatus.PART]: 'Оплачено частично',
  [OrderItem.paymentStatus.OVER]: 'Переплата',
  [OrderItem.paymentStatus.NO]: 'Без оплаты'
})

export const statusOptions = [
  {
    id: 0,
    name: OrderItem.Status.NEW
  },
  {
    id: 1,
    name: OrderItem.Status.DEPARTURE_COURIER_ASSIGNED
  },
  {
    id: 2,
    name: OrderItem.Status.DEPARTURE_COURIER
  },
  {
    id: 3,
    name: OrderItem.Status.DEPARTURE_TERMINAL
  },
  {
    id: 4,
    name: OrderItem.Status.TRANSIT
  },
  {
    id: 5,
    name: OrderItem.Status.DESTINATION_TERMINAL
  },
  {
    id: 6,
    name: OrderItem.Status.DESTINATION_COURIER_ASSIGNED
  },
  {
    id: 7,
    name: OrderItem.Status.DESTINATION_COURIER
  },
  {
    id: 8,
    name: OrderItem.Status.DELIVERED
  },
  {
    id: 9,
    name: OrderItem.Status.CANCEL
  }
]

export const paymentStatusOptions = [
  {
    id: 0,
    name: OrderItem.paymentStatus.FULL
  },
  {
    id: 1,
    name: OrderItem.paymentStatus.PART
  },
  {
    id: 2,

    name: OrderItem.paymentStatus.OVER
  },
  {
    id: 3,
    name: OrderItem.paymentStatus.NO
  }
]

type TOrderAccessName = 'cancel' | 'copy'

export type TOrderAccess = Record<TOrderAccessName, boolean | undefined>

export type TOrderCancelInfo = {
  date: string
  reason: string
}

export type TOrderClient = {
  type: OrderItemClient.type // Тип заказчика/плательщика
  company?: TOrderCompany // Информация о компании
  contact?: TOrderContact // Информация о контакте
}

export type TOrderPartner = OrderItemPartner

export type TOrderCompany = OrderItemCompany

export type TOrderContact = OrderItemContact

export type TOrderPoint = OrderItemPoint

export type TOrderCargo = OrderCargoSeparateItem

export type TOrderCargoTotal = OrderCargoTotal

export type TDetailedPrice = {
  // Цена за выгрузку по адресу (в рублях)
  terminalPrice: string
  // Цена за межтерминальную перевозку (в рублях)
  additionalServicesPrice?: string
  departurePrice?: string
  // Цена за погрузку по адресу (в рублях)
  destinationPrice?: string // Цена за допуслуги за исключением курьерских услуг (в рублях)
}

export type TCheckOutScheduleRequestData = {
  departureTerminalId: string
  destinationTerminalId: string
}

export type TCheckOutSchedule = CheckOutScheduleItem

export interface TTrackingItem {
  // Наименование статуса
  dateTime: string
  statusId: TrackingStatusEnum
  // Идентификатор статуса
  statusName: string // Дата и время изменения статуса (YYYY-MM-DDThh:mm:ss±hh:mm)
  terminalId: string // Идентификатор терминала (id склада из деливери)
  terminalName: string // Название терминала
}

export type TPagination = {
  page: number
  perPage: number
  total: number
}

export type TOrderPayment = PaymentItem

export type TSelectCustomer = {
  hasSpecialCargoLimits: boolean
  id: string
  inn: string
  kpp: string
  name: string
  type: OrderItemClient.type
}

export type GuestCustomer = {
  company: TOrderGuestCreateCompany
  name?: string
}

export type PaymentTransactionCreateRequestWithId = PaymentTransactionCreateFromOrderRequest & { id: string }
